import React from "react"
import { Header, Text, Box, Button } from "@jjordy/layout"
import { Link } from "@reach/router"
import { FaThumbsUp } from "react-icons/fa"
import styled from "styled-components"

const Icon = styled(FaThumbsUp)`
  width: 32px;
  height: 32px;
  fill: ${(props) => props.theme.colors.grey};
`

const SignupSuccess = () => (
  <Box textAlign="center">
    <Header fg="grey">Your almost done!</Header>
    <Icon />
    <Text fg="grey" mb={2}>
      Thanks for signing up we have sent a confirmation email to the email address you provided.
      <br />
      <br />
      <small>Please click the link in the email to finish creating your account.</small>
    </Text>
    <Button as={Link} to="/" bg="success">
      GOT IT
    </Button>
  </Box>
)

export default SignupSuccess
